import clsx from "clsx";
import { FC } from "react";

import { PIC } from "@ryde/assets";

import { NotificationBellStyled } from "./bell.styled";

interface INotificationBellProps {
  isActive?: boolean;
  badgeContent?: number;
  isBadge?: boolean;
}

export const NotificationBell: FC<INotificationBellProps> = ({
  isActive,
  isBadge,
  badgeContent,
}) => {
  return (
    <NotificationBellStyled
      color="error"
      className={clsx("NotificationBell", {
        NotificationBell_Active: isActive,
      })}
      badgeContent={badgeContent}
      invisible={!isBadge}
    >
      <PIC.Bell className="NotificationBell-Icon" data-e2e="svg-bell" />
    </NotificationBellStyled>
  );
};
